module.exports = __webpack_public_path__ + "img/fa-brands-400.ae4fe91a.svg";